
import {
  defineComponent,
  reactive,
  toRefs,
  onMounted,
  watch,
  computed,
} from "vue";
import { useloginStore } from "@/store/login";
import { storeToRefs } from "pinia";
import { apiBuyAndRechargeList } from "@api/home";
import { formatFloatNum } from "@js/utils";
import { yunpb } from "@/types/protobuf";
import Payment from "@component/Payment/index.vue";
import CusModal from "@component/CusModal/index.vue";

interface reactiveType {
  rechargeTypeIdx: number;
  rechargeIndex: number;
  countryPay: yunpb.IThirdPayCountryInfo[];
  // 可以充值的宝石列表
  rechargeGemList: yunpb.IRechargeGem[];
  // 可以充值的金币列表
  rechargeGoldList: yunpb.IRechargeGoldCard[];
  // 当前选中的项 默认为金币下的第一项
  currentSelectItem: yunpb.IRechargeGem | yunpb.IRechargeGoldCard;
}

export default defineComponent({
  name: "rechargeModal",
  components: {
    Payment,
    CusModal,
  },
  setup() {
    const loginStore = useloginStore();
    const {
      isShowRecharge,
      userInfo,
      gems,
      golds,
      isUserPaySuccess,
      isSignIn,
    } = storeToRefs(loginStore);
    const data = reactive<reactiveType>({
      rechargeTypeIdx: 0,
      rechargeIndex: 0,
      countryPay: [],
      rechargeGemList: [],
      rechargeGoldList: [],
      currentSelectItem: {},
    });
    const goodsId = computed(() => {
      return data.rechargeTypeIdx
        ? data.rechargeGemList[data.rechargeIndex].gemCardId
        : data.rechargeGoldList[data.rechargeIndex].id;
    });

    // 选择充值的方式 宝石还是金币
    const selectRechargeTypeIdx = (idx: number) => {
      data.rechargeTypeIdx = idx;
      // 获取一遍数据
      // data.PaymentDom.initPaymentWay(goodsId.value, 1);
    };
    // 选择充值的索引
    const setRechargeIndex = (idx: number) => {
      // rechargeTypeIdx 0是金币，1是宝石
      data.rechargeIndex = idx;
      data.currentSelectItem = data.rechargeTypeIdx
        ? data.rechargeGemList[idx]
        : data.rechargeGoldList[idx];
      // 获取一遍数据
      // data.PaymentDom.initPaymentWay(goodsId.value, 1);
    };
    // 隐藏充值弹窗
    const hideRecharge = () => {
      data.rechargeTypeIdx = 0;
      data.rechargeIndex = 0;
      loginStore.update_isShowRecharge(false, 0);
    };

    // 获取金币、宝石充值的面额列表信息
    const getBuyAndRechargeList = async () => {
      if (!loginStore.isSignIn) return;
      try {
        const PAY_CHANNEL_PC_WEB = 6;
        const res = await apiBuyAndRechargeList({
          payChannel: PAY_CHANNEL_PC_WEB,
        });

        data.rechargeGoldList = res.goldCardList!;
        data.rechargeGemList = res.gemList!;
        data.currentSelectItem = data.rechargeGoldList[0];
        console.log("apiBuyAndRechargeList", res);
      } catch (err) {
        console.error(err);
      }
    };

    // 继续充值  重置充值成功状态
    const continueToRecharge = () => {
      loginStore.update_isUserPaySuccess(false);
    };

    // 每次打开充值弹窗时，重置充值成功状态
    watch(
      () => loginStore.isShowRecharge,
      () => {
        if (loginStore.isShowRecharge) {
          continueToRecharge();
          data.rechargeTypeIdx = loginStore.isShowRechargeTab;
        }
      }
    );

    // 登录后刷新一次 金币、宝石充值的面额列表信息
    watch(
      () => loginStore.isSignIn,
      () => {
        console.log("loginStore.isSignIn", loginStore.isSignIn);
        if (loginStore.isSignIn) getBuyAndRechargeList();
      }
    );

    onMounted(() => {
      getBuyAndRechargeList();
    });

    return {
      ...toRefs(data),
      selectRechargeTypeIdx,
      isShowRecharge,
      isUserPaySuccess,
      isSignIn,
      userInfo,
      gems,
      golds,
      goodsId,
      setRechargeIndex,
      continueToRecharge,
      hideRecharge,
      formatFloatNum,
    };
  },
});
